/* Menu thả xuống ở thanh điều hướng — hai việc phụ mà <details> không tự lo.
 *
 * Việc mở/đóng do chính <details> làm: bấm là mở, Tab + Enter dùng được, và
 * không có JS thì vẫn mở được. File này chỉ thêm hai hành vi mà người dùng
 * mong đợi ở một menu nhưng <details> không có sẵn:
 *
 *   1. bấm ra ngoài thì đóng — nếu không, menu mở rồi cứ nằm đó;
 *   2. bấm Esc thì đóng và trả con trỏ về nhãn, cho người dùng bàn phím.
 *
 * Mở một cái thì đóng cái đang mở: hai hộp cùng bung ra sẽ chồng lên nhau.
 *
 * Gắn ở document chứ không ở từng phần tử: header là section, Shopify thay HTML
 * của nó khi sửa trong theme editor, listener gắn trực tiếp sẽ mất theo.
 */
(function () {
  'use strict';

  var GOC = '.lb-demo .navd';

  function dongHet(tru) {
    document.querySelectorAll(GOC + '[open]').forEach(function (d) {
      if (d !== tru) d.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (e) {
    var trong = e.target.closest ? e.target.closest(GOC) : null;
    if (trong) {
      // Trình duyệt bật/tắt `open` SAU sự kiện này, nên chỉ dọn các cái khác.
      dongHet(trong);
      return;
    }
    dongHet(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var dangMo = document.querySelector(GOC + '[open]');
    if (!dangMo) return;
    dangMo.removeAttribute('open');
    var s = dangMo.querySelector('summary');
    if (s) s.focus();
  });
})();
